module.exports = __webpack_public_path__ + "img/mosaico_1.84b24fa8.png";